/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Button, Dialog , DialogActions, DialogContent, DialogContentText , DialogTitle, Typography, CircularProgress } from '@material-ui/core'

import GroupIcon from '../Groups/GroupIcon';

import Actions from '../../../../../fluid/Actions/ActionFactory'


const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class DeleteGroup extends Component {
    state = {
        deleting : false,
        deleting_error : false
    }

    handleClose = () => {
        this.setState({...this.state, deleting: false, deleting_error: false})
    }

    deleteGroup = () => {
        this.setState({...this.state, deleting : true, deleting_error : false}, () => {
            Actions('http_request', {
                url : "/sainapse/ifc/delete_groups",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    version : this.props.version,
                    group_ids: [this.props.deleting_group.group_id]
                }
            }).then(res => {
                this.setState({...this.state, deleting : false, deleting_error : false}, () => {
                    this.props.refresh_report(() => this.props.confirm_delete())
                })
            }).catch(err => {
                this.setState({...this.state, deleting : false, deleting_error: true})
            })
        })
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Dialog
                    open = {this.props.deleting_group !== null}
                    onClose={this.handleClose}
                >
                    <DialogTitle>{"Deleting a " + this.props.group_display_name + "?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            You are trying to delete the following group. All fields under this group will be made singletons. This action canot be undone. Do you want to proceed?
                            <div style = {{width : '100%', marginTop : '10px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems: 'center'}}>
                                <GroupIcon/>
                                <Typography style = {{marginLeft : '10px'}} variant = 'subtitle2'>{this.props.deleting_group !== null ? this.props.deleting_group.group_name : null}</Typography>
                            </div>
                            {this.state.deleting_error && <div style = {{width : '100%', marginTop : '15px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems: 'center'}}>
                                <Typography variant = 'caption' color = 'secondary'>Error deleting the group.</Typography>
                            </div>}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color = 'secondary'
                            startIcon = {this.state.deleting && <CircularProgress variant = 'indeterminate' color = 'secondary' size = {20}/>}
                            onClick = {this.state.deleting ? null : this.deleteGroup}
                        >
                            {this.state.deleting_error ? "Try Deleting Again" : this.state.deleting ? "Deleting" : "Delete Anyway"}
                        </Button>
                        <Button
                            color = 'primary'
                            onClick = {this.props.cancel_delete}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(DeleteGroup);